// extracted by mini-css-extract-plugin
var _1 = "kCbpf5HoT0";
export { _1 as "root" }
